import {
  Box, Button, Icon, Text,
} from '@usealloy/component-library';
import styled from 'styled-components';


export const StyledRelativeContainer = styled.div`
  position: relative;
  z-index: 10;
`;

export const StyledAbsoluteContainer = styled.div`
  position: absolute;
  right: 40px;
`;

export const StyledSearchBoxContainer = styled.div`
  min-width: 392px;
  max-width: 392px;
  align-self: end;
  padding: var(--cl-space-3);
  background: white;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  border-bottom-left-radius: var(--cl-space-2);
  border-bottom-right-radius: var(--cl-space-2);
`;

export const StyledSearchInput = styled.input`
  border: none;
  font-size: 0.85rem;
  width: 100%;
  &&& {
    border: none;
    outline: none;
  }
  /* disables the blue outline when being edited */
  :focus-visible { 
    outline: none;
    border: none;
  }
`;

export const StyledSearchIcon = styled(Icon)`
  min-width: 24px;
  min-height: 24px;
`;


export const StyledNoResultsText = styled(Text)`
  color: var(--cl-gray-700);
  &&& {
    margin-right: var(--cl-space-2);
    white-space: nowrap;
  }
`;

export const StyledResultsText = styled(Text)`
  color: var(--cl-gray-700);
  text-align: right;
  flex-grow: 1;
`;


export const StyledSearchBoxControlContainer = styled(Box)`
`;

export const StyledSearchBoxControlButton = styled(Button)`
  &&& {
    width: 32px;
    height: 32px;
    padding: var(--cl-space-1);
  }
`;

